const styles = {
	color: 'primary.main',
	mt: 1,
	mb: 1,
	cursor: 'default',
	fontWeight: 900
}

export default styles
